import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task(
        $ids: [String]
        $type: String
        $page: Int
        $code: String
        $limit: Int
        $statuses: [String]
        $do_date: String
        $shop_id: String
        # $user_id: String
        $unit_id: String
        $booth_id: String
        $order_id: String
        $coupon_id: String
        $product_id: String
        # $my_request: Int
        $for_role_ids: [String]
        $for_user_id: String
        $for_shop_ids: [String]
        $request_date: String
        $settlement_id: String
        $orderBy_field: String
        $product_shop_id: String
        $orderBy_direction: String
        $belongs_to_me: Int
      ) {
        task(
          ids: $ids
          type: $type
          page: $page
          code: $code
          limit: $limit
          statuses: $statuses
          do_date: $do_date
          shop_id: $shop_id
          # user_id: $user_id
          unit_id: $unit_id
          booth_id: $booth_id
          order_id: $order_id
          coupon_id: $coupon_id
          product_id: $product_id
          # my_request: $my_request
          for_role_ids: $for_role_ids
          for_user_id: $for_user_id
          for_shop_ids: $for_shop_ids
          request_date: $request_date
          settlement_id: $settlement_id
          orderBy_field: $orderBy_field
          product_shop_id: $product_shop_id
          orderBy_direction: $orderBy_direction
          belongs_to_me: $belongs_to_me
        ) {
          total
          last_page
          data {
            id
            type
            status
            request_date
            media {
              id
              full_url
            }
            user {
              id
              firstname
              lastname
              cellphone
            }
            shop {
              title
            }
            unit {
              title
            }
            booth {
              title
            }
            coupon {
              title
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteRequest',
    serviceName: 'auth',
    query: gql`
      mutation deleteRequest($ids: [String]!) {
        deleteRequest(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task($ids: [String]) {
        task(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task($ids: [String]) {
        task(ids: $ids) {
          data {
            id
            type
          }
        }
      }
    `,
  },
};

export default schema;
